<template>
   <transition name="el-zoom-in-left"> 
  <div class="">
    <div class="condition clearfix" id="contain">
      <el-form :inline="true" :model="conditions" style="min-width: 1160px;" class="demo-form-inline clearfix" ref="conditions">
        <div class="clearfix" style="margin-bottom: 0px;">
          <!-- search start-->
          <!--   <el-form-item label="调拨订单编号：" class="tinp">
                        <el-input v-model="conditions.to_billcode" placeholder="请输入调拨订单编号" suffix-icon="el-icon-search" clearable @change="onParamChange"></el-input>
                    </el-form-item>  -->
          <!--  <el-form-item label="申请时间：" class="tinp searchtime":class="{iconshow:showicon}">
                       <el-date-picker value-format="yyyy-MM-dd" v-model="conditions.time" type="date" placeholder="选择日期" @change="onParamChange"  @mouseover.native="cleandataicon" @mouseout.native="cleandataicon" >
                      </el-date-picker>
                    </el-form-item> -->
          <!--  <el-form-item label="调出门店：" class="tinp">
                        <el-input v-model="conditions.moutstorename" placeholder="请输入调出门店" suffix-icon="el-icon-search" clearable @change="onParamChange"></el-input>
                    </el-form-item> -->
          <!-- <el-form-item label="申请人：" class="tinp">
                        <el-input v-model="conditions.cinpsnidname" placeholder="请输入申请人" suffix-icon="el-icon-search" clearable @change="onParamChange"></el-input>
                    </el-form-item> -->
          <!--  <el-form-item label="商品名：" class="tinp">
                        <el-input v-model="conditions.productName" placeholder="请输入申请人" suffix-icon="el-icon-search" clearable @change="onParamChange"></el-input>
                    </el-form-item> -->
          <!-- search end -->
          <!-- <el-button type="primary" class="" size="small" icon="el-icon-search" @click="onParamChange">搜索</el-button> -->
        </div>
        <!-- tablelist start -->
                <!-- <span class="fl tabletitle">到货单单号：{{item.ic_billcode}}</span> -->
       <!--  <div class="tablebox" style="margin-top: 0px;" v-if="count >= 1">
          <table class="bigtablelist" style="border: 1px solid #56B8AA;margin-bottom: 10px;" v-for="(item,index) in tableList">
            <tr style="border: 1px solid #56B8AA;background:#fff;color: #333;height:45px">
              <th :id="item.to_billcode" style="width:2rem;font-color:#56B8AA;background-color:#fff;position:relative" @click="showlist(item,index)">
                <i class="iconfont icon-jiantou_yemian_xiangshang jiantouxia" v-bind:class="{'jiantoushang':item.listshow =='N'}" style="color: #56B8AA;font-size: 22px;font-weight: 100;"></i></th> 
              <th colspan="11"> 
                <span class="fl tabletitle">调拨订单号：{{item.to_billcode}}</span> 
                <span class="fl tabletitle">调出门店：{{item.stockorgname}}</span>
                <span class="fr tabletitle">出库日期：{{item.dbilldate}}</span>
                <span class="fr tabletitle">快递单号：{{item.couriernumber}}</span>
                <span class="fr tabletitle">快递公司：{{item.couriername}}</span> 
              </th>
            </tr>
            <tr style="border: 1px solid #56B8AA;background: #56B8AA;color: #fff;height:45px" v-show="item.listshow =='N'">
              <th style="width:" >行号</th> 
              <th style="width:" v-for="head in tableHeads" class="">
                <span>{{head.label }}</span>
              </th>
              <th>收货货位</th>
              <th style="border: 1px solid #56B8AA;">操作</th>
            </tr>
            <tr class="trbg" v-for="(data,index2) in item.productList" :class="{bordercolor: getclass(index2,item)}" :key="item.pkApplybillB" v-show="item.listshow =='N'">
              <td>{{index2+1}}</td> 
              <td>
                <span >{{data.materialcode}}</span>
              </td>
              <td>
                <span >{{data.materialname}}</span>
              </td>
              <td>
                <span >{{data.measdocname}}</span>
              </td> 
              <td>
                <span >{{data.nnum}}</span>
              </td>
              <td style="width:150px">
                <el-input class="tabinp" v-model="data.memo" clearable></el-input>
              </td>
               <td class="" style="width:140px"> 
                <el-input v-model="data.hinpositionname" suffix-icon="el-icon-search" v-on:click.native="openselectmodel(index,index2)"></el-input> 
              </td>
              <td style="border-right: 1px solid #56B8AA; height: 38px;width:150px" class="noborder">
                <el-button v-if="index2=='0'" type="primary" class="" size="mini" @click="submit(index)">确认收货</el-button>
              </td>
            </tr>
          </table>
        </div>
        <div class="msgNone" v-else style="text-align: center;font-size: 15px;color: #333;margin-top: 20px">
          <span>暂无数据</span>
        </div> -->
        <!--  :style="{'width': width}" --> 
         <div class="order-list-table" v-if="count >= 1">
        <table v-for="(data,index) in tableList" v-if="data.productList.length>=1" class="downtablelist bigtablelist">
          <tr>
            <th :id="data.to_billcode" style="width:2rem;font-color:#56B8AA;background-color:#fff;position:relative" @click="showlist(data,index)">
              <i class="iconfont icon-jiantou_yemian_xiangshang jiantouxia" v-bind:class="{'jiantoushang':data.listshow =='N'}" style="color: #56B8AA;font-size: 22px;font-weight: 100;"></i>
            </th>
           <!--  <th class="allckeck" style="width:3rem" v-show="data.listshow =='N'">
              <div class="item-all-check">
                <span  class="checkbox-btn item-check-btn" v-bind:class="{'checked':data.allchecked=='Y'}" @click="toggleCheckAll(data,index)">
                   <span class="iconfont icon-duigou gou" style="font-size: 12px"></span>
                </span>
              </div>
            </th> -->
            <th colspan="7" class="thbox" style="padding:0 10px">
                <span class="fl tabletitle">调拨订单号：{{data.to_billcode}}</span> 
                <span class="fl tabletitle">调出门店：{{data.deptdrname}}</span>
                <span class="fr tabletitle">出库日期：{{data.dbilldate}}</span>
                <span class="fr tabletitle">快递单号：{{data.couriernumber}}</span>
                <span class="fr tabletitle">快递公司：{{data.couriername}}</span> 
            </th>
          </tr> 
          <tr class="first noimg" v-show="data.listshow =='N'">
            <td bgcolor="#EFF0F4" style="border:1px solid #EFF0F4"></td>
            <!-- <td class="fir" style="color: #fff;"></td>  -->
            <td style="width:120px" class="tdtitle">商品编码</td>
            <td style="width:190px" class="tdtitle">商品名称</td>
            <td style="width:72px" class="tdtitle">主单位</td> 
            <td style="width:72px" class="tdtitle">收货数量</td>
            <td style="width:72px" class="tdtitle">备注</td>
            <td style="width:72px" class="tdtitle">调入货位</td>
            <td style="width:110px;text-align: center;padding-right: 20px !important" class="lastbut tdtitle">
              操作
            </td>
          </tr>
          <tr v-for="(item,index2) in data.productList" class="first noimg" v-show="data.listshow =='N'">
            <td bgcolor="#EFF0F4"></td>
           <!--  <td class="fir" style="color: #fff;">
              <div class="list-item-check">
                <span class="checkbox-btn item-check-btn" v-bind:class="{'checked':item.checked=='1'}" @click="choose(item,data,index)">
                <span class="iconfont icon-duigou" style="font-size: 12px"></span>
                </span>
              </div> 
            </td>  -->
             
            <td style="width:12%">{{ item.materialcode }}</td>
            <td style="width:18%">{{ item.materialname }}</td>
            <td style="width:12%">{{ item.measdocname }}</td>
            <td style="width:8%">{{ item.nnum }}</td>  
            <td style="width:150px">
                <el-input class="tabinp" v-model="item.memo" clearable></el-input>
              </td>
               <td class="" style="width:140px"> 
                <el-input v-model="item.hinpositionname" suffix-icon="el-icon-search" v-on:click.native="openselectmodel(index,index2)"></el-input> 
            </td> 
            <td style="width:110px;text-align: center;padding-right: 20px !important" class="lastbut">
             <el-button type="primary" class="" size="small" @click="submit(index)" v-if="index2==0">确认收货</el-button>
            </td>
          </tr>
        </table>
      </div>
      <div class="msgNone" v-else style="text-align: center;font-size: 15px;color: #333;margin-top: 20px">
        <span>暂无数据</span>
      </div>
        <!-- tablelist end -->
        <!-- fenye start -->
        <div class="block" style="text-align: center;margin:20px auto ">
          <span>
                    <el-pagination class="fenye" @size-change="handleSizeChange" @current-change="handleCurrentChange"  background
                      :current-page="page"
                      :page-size="pagesize"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="count">
                    </el-pagination>
                    </span>
        </div>
        <!-- fenye end -->
      </el-form>
    </div>
     <!-- model start -->
    <div class="model selectmodel" v-show="modelShow">
      <div class="content">
        <div class="title">
          <span class="fl">选择货位</span>
          <span class="fr" @click="closemodel"><i class="iconfont icon-guanbi"></i></span>
        </div>
        <div class="selectinput">
          <el-form :inline="true" style="padding:10px">
            <el-form-item class="" style="width:100%;margin: 0 !important">
              <el-select @change="selectchange" filterable value-key="positioncode" v-model="position.positionname" clearable placeholder="请选择货位" style="width:100%;" auto-complete="off">
                <el-option v-for="item in positionList" :key="item.positioncode" :label="item.positionname" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <!-- model end -->
    <div class="" v-loading.fullscreen.lock="fullscreenLoading"></div> 
    <!-- 弹窗 start --> 
      <MessageModel types="提示信息" :msg="msg" :msgShow="msgShow" :flag="modelFlag" :butmsg="butmsg" :butflag = "butflag" @modelmsg="returnMsg"></MessageModel>  
  </div>
  </transition> 
</template>
<script>
// import MessageModel from '../../components/MessageModel'
export default {
  name: '',
  data() {
    return {
      flag:false,
      msgShow:false,
      modelFlag:false,
      modelFlag2:false,
      butflag:true,
      butflag2:true,
      msg:'', 
      butmsg:'确认', 
      butmsg2:'确认', 
      methodName:'', 
      utilpath: '',
      fullscreenLoading: false,
      modelShow: false,
      width: '',
      index1: '',
      index0: 0,
      tableListindex: '',
      page: 1,
      pagesize: 10,
      count: 0,
      id: '',
      step: 0,
      index: 0,
      row: 0,
      changebgcolor: -1,
      user: {},
      showicon: false,
      diaoboshow: false,
      conditions: {
        to_billcode: '', //申请单号
        cinpsnidname: '', //申请人
        moutstorename: '', //申请门店
        productName: '', //商品名
        time: '', //申请时间
      },
      tableList: [],
      position: {
        positioncode: '', //货位编码
        positionname: '', //货位名称
      },
      positionList: [],
      tableData: {},
      tableinput: {},
      tableHeads: [
        // {
        //        label: '调入仓库',
        //        key: 'cinrepertoryname'
        //    },
        {
          label: '商品编码',
          key: 'materialcode'
        },
        {
          label: '商品名称',
          key: 'materialname'
        },
        // {
        //     label: '规格',
        //     key: 'wlspec'
        // },
        // {
        //     label: '型号',
        //     key: 'wltype'
        // },
        {
          label: '主单位',
          key: 'cunitname'
        },
        // {
        //     label: '批次号',
        //     key: 'vbatchcode'
        // },
        // {
        //     label: '申请数量',
        //     key: 'nnum'
        // },
        // {
        //     label: '调拨数量',
        //     key: 'outnum'
        // }, 
        {
          label: '本次收货数量',
          key: 'nnum'
        },
        {
          label: '备注',
          key: 'vnotebody'
        }
      ]
    }
  },
  mounted() {
    // 获取接口名
    this.InterfacePath = window.localStorage.getItem("InterfacePath");
    this.utilpath = this.axios.defaults.baseURL;
    this.init();
  },
  destroyed() {
    sessionStorage.removeItem("to_billcode");
    sessionStorage.removeItem("cinpsnidname");
    sessionStorage.removeItem("time");
    sessionStorage.removeItem("page");
    sessionStorage.removeItem("pagesize");
    sessionStorage.removeItem("diaobolist");
  },
  methods: {
    //关闭弹窗
    closemodel() { 
        this.modelShow = false; 
    },
    selectchange(value) { 
      this.tableList[this.index0].productList[this.tableListindex].hinpositioncode = value.positioncode;
      this.tableList[this.index0].productList[this.tableListindex].hinpositionname = value.positionname;
      // this.tableList[this.index0].productList.forEach((item) => {
      //   console.log("打印：" + JSON.stringify(item));
      // }); 
      this.modelShow = false;
      this.position = {
        positioncode: '',
        positionname: ''
      };
    },
     openselectmodel(index,index2) {
      // console.log("model内打印：" + index);
      this.index0 = index;
      this.tableListindex = index2;
      this.modelShow = true;
    },
    returnMsg(flag){ 
      this.modelFlag = false;
      if(flag){
            // console.log("---进来了！！！----"+this.methodName);
            if(this.methodName =='method2'){
              this.fullscreenLoading = true;
               var reparme = {
                  applybill: JSON.stringify(this.tableList[this.index])
                };
                // console.log("打印参数111111111"+JSON.stringify(this.tableList[this.index]));
                //获取数据接口 
                // this.$post('/confirmBill",reparme,{emulateJSON:true})
                this.$http.post(this.utilpath + '/takeOverApplybill', reparme, { emulateJSON: true,_timeout:600 })
                  // this.$http.post("/ktnapi/confirmBill",reparme,{emulateJSON:true})
                  // this.$http.post(this.InterfacePath+"/confirmBill",reparme,{emulateJSON:true}) 
                  .then((res) => {
                    if (res.data.status == '0') {
                      this.fullscreenLoading = false;
                      this.tableList = res.data.resultList;
                      this.$message({
                        showClose: true,
                        message: '收货成功！',
                        type: 'succcess'
                      });
                      this.count = res.data.countNum;
                      sessionStorage.setItem("diaobolist", JSON.stringify(this.tableList));
                    } else if(res.data.status == '9'){
                      this.fullscreenLoading =false;
                      this.$router.push({path:'/ui/login',query:{msg:9}});
                    } else { 
                        this.fullscreenLoading = false;
                        this.msgShow = true;
                        this.modelFlag = true;
                        this.methodName = 'message';
                        this.msg = res.data.message;
                        this.butflag =false;
                        this.butmsg='知道了'; 
                    }
                  }, (err) => {
                        this.fullscreenLoading = false;
                        this.modelFlag = true;
                        this.msgShow = false;
                        this.methodName = 'message';
                        this.msg = '连接接口失败';
                        this.butflag =false;
                        this.butmsg='知道了'; 
                  });
            }
      }else{
        this.$message({
          showClose:true,
          message:'已取消',
          type:'succcess'
        })
      }
    }, 
    getclass(index2, item) {

      if (index2 == item.productList.length) {
        return true;
      }
    },
    // 单选点击事件
    choose(item, data, index) {
      item.checked = item.checked == "1" ? '0' : '1';
      data.productList.forEach((item) => {
          // console.log("check"+item.checked);
        if (item.checked != '1') {

          data.allchecked = 'N';
          return;
        }else{
          data.allchecked = 'Y';

        }
      });
      var money = 0;
      data.productList.forEach((item2) => {
        if (item2.checked == '1') {
          money += parseFloat(item2.ntaxmny);
        };
      });
      this.tableList[index].ntotaltaxmny = money;
    },
    // 全选点击事件
    toggleCheckAll(data, index) {
      // console.log("data" + data.productList);
      data.allchecked = data.allchecked == 'N' ? 'Y' : 'N';

      data.productList.forEach((item) => {
        item.checked = data.allchecked == 'Y' ? '1' : '0';
        // console.log(item.checked + "-=-=-=-=打印选中状态-=-=-==");
      });
      var money = 0;
      data.productList.forEach((item2) => {
        if (item2.checked == '1') {
          money += parseFloat(item2.ntaxmny);
        };
      });
      this.tableList[index].ntotaltaxmny = money; 
      // console.log(data.allchecked + "-=-=-=-=打印选中状态-=-=-==");
    },
    //显示隐藏表格
    showlist(item, index) { 
      // 取反(true或false)
      this.tableList[index].listshow = item.listshow == 'Y' ? 'N' : 'Y';
      // console.log("展开方法"+this.tableList[index].listshow); 
      this.index1 = index;
      this.id = item.to_billcode;
      this.toTop(); 
      // console.log("打印数据调拨单数据-=-=-=-=-==-：" + JSON.stringify(this.tableList[index]));
      sessionStorage.setItem("diaobolist", JSON.stringify(this.tableList));
    },
    toTop() {
      var idmsg = '';
      if (this.id != '') {
        idmsg = this.id;
      } else {
        idmsg = 'contain';
      }
      // console.log("_+_+_+_+_+打印id" + this.id);
      //参数i表示间隔的幅度大小，以此来控制速度
      var dis = (document.getElementById(idmsg).scrollTop) / 8
      this.step = dis;
      document.getElementById(idmsg).scrollTop -= dis;
      var scroll = document.getElementById(idmsg).scrollTop;
      if (scroll > 0) {
        // console.log("回到顶部循环内" + document.getElementById(idmsg).scrollTop);
        this.step += dis
        var c = setTimeout(() => this.toTop(this.step), 16);
      } else {
        clearTimeout(c);
      }
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.pagesize = val;
      this.page=1; 
      // this.getList();
      // console.log(this.pagesize);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.page = val;
      // console.log(this.page);
      this.getList();
    },
    cleandataicon() {
      // console.log("划过");
      if (this.conditions.time != '') {
        this.showicon = !this.showicon;
      }
      if (this.conditions.time == null) {
        this.showicon = false;
      }
    },
    getposition(){
      //获取数据接口
      var reqParam = {
        storecode: this.user.storecode,
      };
      this.$http.post(this.utilpath + '/selectStorespositioninfo', reqParam, { emulateJSON: true,_timeout:600 }).then((res) => {
        // this.$http.post('/ktnapi/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        //this.$post('/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => { 
        if (res.data.status == '0') {
          var positions = res.data.resultList;
          //var positions=res.data.result;
          this.positionList = [];
          for (var i = positions.length - 1; i > -1; i--) {
            this.positionList.push({ positionname: positions[i].positionname, positioncode: positions[i].positioncode });
          }
          // console.log("打印货位" + JSON.stringify(this.positionList));
        } else if(res.data.status == '9'){
            this.fullscreenLoading =false;
            this.$router.push({path:'/ui/login',query:{msg:9}});
        }  else {
          this.modelFlag = true;
          this.msgShow = true;
          this.methodName = 'message';
          this.msg = res.data.message;
          this.butflag =false;
          this.butmsg='知道了'; 
        }       
      }, (err) => {
          this.modelFlag = true;
          this.msgShow = false;
          this.methodName = 'message';
          this.msg = '获取货位接口失败';
          this.butflag =false;
          this.butmsg='知道了'; 
      });
    },
    //获取数据
    getList() {
      this.fullscreenLoading = true;
      // console.log("111打印加载状态："+this.fullscreenLoading);
      let reqParam = {
        //to_billcode: this.conditions.to_billcode,//申请单号 
        // moutstorename: this.conditions.moutstorename,//申请门店 
        // productName: this.conditions.productName,//申请门店
        // time: this.conditions.time,//申请时间
        pageNum: this.page, //当前页
        pageSize: this.pagesize, //页面数据条数
        forderstatus: '4',
        minstorecode: this.user.storecode
      }
      // sessionStorage.setItem("to_billcode",this.conditions.to_billcode);
      // sessionStorage.setItem("cinpsnidname",this.conditions.cinpsnidname);
      // sessionStorage.setItem("time",this.conditions.time);
      sessionStorage.setItem("page", this.page);
      sessionStorage.setItem("pagesize", this.pagesize); 
      //获取数据接口 
      this.$http.post(this.utilpath + '/selectTransout', reqParam, { emulateJSON: true,_timeout:600 }).then((res) => {
        // this.$http.post('/ktnapi/selectTransout', reqParam,{emulateJSON:true}).then((res) => {
        // this.$post('/selectTransout', reqParam,{emulateJSON:true}).then((res) => { 
        if (res.data.status == '0') { 
          this.fullscreenLoading = false, 
          this.tableList = res.data.resultList;  
          sessionStorage.setItem("diaobolist", JSON.stringify(this.tableList));
          this.count = res.data.countNum;  
        } else if (res.data.status == '-1') {
          this.fullscreenLoading = false,
            this.tableList = [];
          this.$message({
            showClose: true,
            message: '暂无数据！',
            type: 'succcess'
          });
          this.count = res.data.countNum; 
        } else if(res.data.status == '9'){
          this.fullscreenLoading =false;
          this.$router.push({path:'/ui/login',query:{msg:9}});
        }  else {
          this.fullscreenLoading = false,
          this.modelFlag = true;
          this.msgShow = true;
            this.methodName = 'message';
            this.msg = res.data.message;
            this.butflag =false;
            this.butmsg='知道了'; 
        }
      }, (err) => {
        this.fullscreenLoading = false,
        this.modelFlag = true;
        this.msgShow = false;
        this.methodName = 'message';
        this.msg = '连接查询调拨单接口失败';
        this.butflag =false;
        this.butmsg='知道了'; 
      });

    },
    init() {
      //sessionStorage.removeItem("weilist");
      this.user = JSON.parse(window.localStorage.getItem("userInfo"));
      // var inp1 = sessionStorage.getItem("to_billcode");
      // var inp2 = sessionStorage.getItem("cinpsnidname");
      // var inp3 = sessionStorage.getItem("time");
      // if(inp1 != null){
      //    this.conditions.to_billcode = inp1;
      // }
      // if(inp2 != null){
      //     this.conditions.cinpsnidname = inp2;
      // }
      // if(inp3 != null){
      //     this.conditions.time = inp3;
      // }
      var bigdata = JSON.parse(sessionStorage.getItem("diaobolist")); 
      if (bigdata != null) {
        this.fullscreenLoading = false;
        this.tableList = bigdata;
        this.count = this.tableList.length;
        this.page = parseFloat(sessionStorage.getItem("page"));
        this.pagesize = parseFloat(sessionStorage.getItem("pagesize"));
      } else {
        this.getposition();
        this.getList();
      }
    },
    submit(index) {
      var count = 0;
        this.tableList[index].productList.forEach((item) => {
          if (item.hinpositioncode == null || item.hinpositioncode == '') {
            ++count
          }
        });
           this.index = index;
        if (count == 0) { 
           this.methodName ='method2' 
           this.modelFlag = true;
           this.msgShow = false;
           this.butflag = true;
           this.butmsg='确认';
           this.msg = '确定提交收货单？';
        } else { 
           this.methodName ='method'
           this.modelFlag = true;
           this.msgShow = false;
           this.msg = '请选择收货货位！';
           this.butflag = false;
           this.butmsg = '知道了'; 
        }  
    },
    //搜索框变化事件
    onParamChange() {
      // sessionStorage.setItem("diaobolist", JSON.stringify(this.tableList));

    }
  }
}

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/receives/diaobo.vue